import { FormControl, MenuItem, Select } from '@mui/material';
import { Roles } from 'components/generics/Interface/Api/Response/User/IUser';
import { GridFilterInputValueProps, GridFilterOperator } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';
import i18next from 'i18n';

function CustomFilterSelectRightValue(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const { t } = useTranslation();

  const handleFilterChange = (event: any) => {
    applyValue({ ...item, value: event.target.value });
  };

  return (
    <FormControl>
      <Select value={item.value ?? 'all'} onChange={handleFilterChange}>
        <MenuItem value="all">{t('common.all')}</MenuItem>
        <MenuItem value="true">{t('label.authorized')}</MenuItem>
        <MenuItem value="false">{t('label.forbidden')}</MenuItem>
        <MenuItem value="null">{t('label.notDefined')}</MenuItem>
      </Select>
    </FormControl>
  );
}

function CustomFilterSelectRole(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const { t } = useTranslation();

  const handleFilterChange = (event: any) => {
    applyValue({ ...item, value: event.target.value });
  };

  return (
    <FormControl>
      <Select value={item.value ?? 'all'} onChange={handleFilterChange}>
        <MenuItem value="all">{t('common.all')}</MenuItem>
        <MenuItem value={Roles.ADMIN}>{t('role.admin')}</MenuItem>
        <MenuItem value={Roles.TECHNICIAN}>{t('role.technician')}</MenuItem>
        <MenuItem value={Roles.FARMER}>{t('form.farmer')}</MenuItem>
      </Select>
    </FormControl>
  );
}

export const functionlityOperators: GridFilterOperator<any, boolean | null>[] = [
  {
    label: i18next.t('label.equalTo'),
    value: 'is',
    getApplyFilterFn: (filterItem) => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator) {
        return null;
      }
      return (value) => {
        if (filterItem.value === 'true') {
          return value === true;
        }
        if (filterItem.value === 'false') {
          return value === false;
        }
        if (filterItem.value === 'null') {
          return value === null;
        }
        return true;
      };
    },
    InputComponent: CustomFilterSelectRightValue,
  },
];

export const userRoleOperators: GridFilterOperator<any, string>[] = [
  {
    label: i18next.t('label.equalTo'),
    value: 'is',
    getApplyFilterFn: (filterItem) => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator) {
        return null;
      }
      return (value, row) => {
        if (filterItem.value === 'all') {
          return true;
        }
        return row.role === filterItem.value;
      };
    },
    InputComponent: CustomFilterSelectRole,
  },
];
